import { FormBase } from 'core/components';

export default class VoidLabelForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'voidLabelOptionId',
					label: 'VOIDLABELVIEW.VOIDLABELOPTION',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/VoidLabelForm.js